import auth from '@/i18n/de/auth.json'
import pages from '@/i18n/de/pages.json'
import account from '@/i18n/de/account.json'
import error from '@/i18n/de/error.json'
import base from '@/i18n/de/base.json'
import validation from '@/i18n/de/validation.json'
import session from '@/i18n/de/session.json'
import date from '@/i18n/de/date.json'
import profile from '@/i18n/de/profile.json'
import avatar from '@/i18n/de/avatar.json'
import location from '@/i18n/de/location.json'
import nationality from '@/i18n/de/nationality.json'
import hobbies from '@/i18n/de/hobbies.json'
import languages from '@/i18n/de/languages.json'
import note from '@/i18n/de/note.json'
import marriage from '@/i18n/de/marriage.json'
import children_count from '@/i18n/de/children-count.json'
import drivers from '@/i18n/de/drivers.json'
import way_to_work from '@/i18n/de/way-to-work.json'
import file from '@/i18n/de/file.json'
import gender from '@/i18n/de/gender.json'
import candidate_invite from '@/i18n/de/candidate-invite.json'
import contacts from '@/i18n/de/contacts.json'
import education from '@/i18n/de/education.json'
import institution from '@/i18n/de/institution.json'
import skills from '@/i18n/de/skills.json'
import interview_profile from '@/i18n/de/interview-profile.json'
import interview_candidate from '@/i18n/de/interview-candidate.json'
import travel from '@/i18n/de/travel.json'
import current_employment_status from '@/i18n/de/current-employment-status.json'
import work_notice_period from '@/i18n/de/work-notice-period.json'
import experience from '@/i18n/de/experience.json'
import education_degree from '@/i18n/de/education-degree.json'
import residence_permit_germany from '@/i18n/de/residence-permit-germany.json'
import distance_unit from '@/i18n/de/distance-unit.json'
import company from '@/i18n/de/company.json'
import residence_permit from '@/i18n/de/residence-permit.json'
import market from '@/i18n/de/market.json'
import employment from '@/i18n/de/employment.json'
import candidate_dashboard from '@/i18n/de/candidate-dashboard.json'
import vacancy from '@/i18n/de/vacancy.json'
import chat from '@/i18n/de/chat.json'
import process from '@/i18n/de/process.json'
import calendar_event from '@/i18n/de/calendar-event.json'
import experience_level from '@/i18n/de/experience_level.json'
import experience_positions from '@/i18n/de/experience_positions.json'
import benefits from '@/i18n/de/benefits.json'
import career_position from '@/i18n/de/career-position.json'
import cookies from '@/i18n/de/cookies.json'
import pagination from '@/i18n/de/pagination.json'
import footer from '@/i18n/de/footer.json'
import social from '@/i18n/de/social.json'
import help from '@/i18n/de/help.json'

export default {
  validation,
  auth,
  pages,
  account,
  error,
  base,
  session,
  date,
  profile,
  avatar,
  note,
  location,
  nationality,
  hobbies,
  languages,
  marriage,
  children_count,
  drivers,
  way_to_work,
  file,
  gender,
  company,
  candidate_invite,
  contacts,
  education,
  institution,
  education_degree,
  skills,
  interview_profile,
  interview_candidate,
  travel,
  current_employment_status,
  work_notice_period,
  experience,
  market,
  residence_permit_germany,
  distance_unit,
  residence_permit,
  candidate_dashboard,
  employment,
  chat,
  process,
  calendar_event,
  cookies,
  vacancy,
  benefits,
  experience_level,
  experience_positions,
  career_position,
  pagination,
  social,
  help,
  ...footer
}
